module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "pvi"
    }
  }), _vm._v(" Copyright © 2006 by Rita Williams")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced"), _c('br'), _vm._v("\nor transmitted in any form or by any means, electronic or mechanical,"), _c('br'), _vm._v("\nincluding photocopy, recording, or any information storage and"), _c('br'), _vm._v("\nretrieval system, without permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Requests for permission to make copies of any part of the work"), _c('br'), _vm._v("\nshould be mailed to the following address: Permissions Department,"), _c('br'), _vm._v("\nHarcourt, Inc., 6277 Sea Harbor Drive, Orlando, Florida 32887-6777.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "http://www.HarcourtBooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.HarcourtBooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("The Library of Congress has cataloged the hardcover edition as follows:"), _c('br'), _vm._v("\nWilliams, Rita (Rita Ann)"), _c('br'), _vm._v("\nIf the creek don't rise: my life out West with the last Black"), _c('br'), _vm._v("\nwidow of the Civil War/Rita Williams.—1st ed."), _c('br'), _vm._v("\np. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("1. Williams, Rita (Rita Ann) 2. African American"), _c('br'), _vm._v("\nwomen—Biography. 3. African Americans—Biography."), _c('br'), _vm._v("\n4. Colorado—Biography. I. Title."), _c('br'), _vm._v("\nE185.97.W73A3 2006"), _c('br'), _vm._v("\n978.8'00496073092—dc22 2006000335"), _c('br'), _vm._v("\nISBN 978-0-15-101154-4"), _c('br'), _vm._v("\nISBN 978-0-15-603285-8 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Text set in Fournier"), _c('br'), _vm._v("\nDesigned by Cathy Riggs")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("First Harvest edition 2007"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("K J I H G F E D C B A")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1152e084","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0